import { render, staticRenderFns } from "./PluginDetails.vue?vue&type=template&id=bf5b7786&"
import script from "./PluginDetails.vue?vue&type=script&setup=true&lang=js&"
export * from "./PluginDetails.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports